import { render, staticRenderFns } from "./maintainTags.vue?vue&type=template&id=5c5b2166&scoped=true"
import script from "./maintainTags.vue?vue&type=script&lang=js"
export * from "./maintainTags.vue?vue&type=script&lang=js"
import style0 from "./maintainTags.vue?vue&type=style&index=0&id=5c5b2166&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5b2166",
  null
  
)

export default component.exports